// services/features/featureChangeApi.ts
import { fetchCompatibleVendors } from "../../utils/api-service/get-services"

// featureChangeApi.ts
export const fetchHardwareVendorHelper = async (values, helpers) => {
    console.log("fetchHardwareVendorHelper called with:", {
        country: values?.location,
        hardwareType: values?.hardware?.hardwareType,
        motorizedType: values?.hardware?.motorizedType,
        pleat: values?.pleat,
        hasVendor: !!values?.hardware?.vendor
    })

    const { setOptions, handleFeatureChange } = helpers

    if (
        values?.hardware?.hardwareType &&
        values?.hardware?.hardwareType !== "NONE"
    ) {
        try {
            const response = await fetchCompatibleVendors({
                country: values?.location,
                hardwareType: values?.hardware?.hardwareType,
                motorizedType: values?.hardware?.motorizedType,
                pleat: values?.pleat,
                productType: values?.parentProductType
            })

            console.log("Vendor API response:", response)

            if (response.success === true) {
                const vendorOptions =
                    response?.vendors?.map(vendor => ({
                        value: vendor._id,
                        label: vendor.name
                    })) || []

                console.log("Setting vendor options:", vendorOptions)
                setOptions("hardware.vendor", [
                    { label: "Select Vendor", disabled: true, value: "" },
                    ...vendorOptions
                ])

                // Clear invalid vendor selection
                if (
                    values?.hardware?.vendor &&
                    !response?.vendors?.some(v => v._id === values?.hardware?.vendor)
                ) {
                    console.log("Clearing invalid vendor selection")
                    await handleFeatureChange("hardware.vendor", "")
                }
            } else {
                console.log("Vendor fetch failed:", response.message)
                setOptions("hardware.vendor", [])
            }
        } catch (error) {
            console.error("Error fetching vendors:", error)
            setOptions("hardware.vendor", [])
        }
    } else {
        console.log("Conditions not met for vendor fetch, clearing options")
        setOptions("hardware.vendor", [])
        if (values?.hardware?.vendor) {
            await handleFeatureChange("hardware.vendor", "")
        }
    }
}
